// @ts-nocheck
import React from "react";
import { CloseOutlined, PrinterOutlined } from "@ant-design/icons";
import { Button, Modal, Space, Typography } from "antd";
import { getColumns } from "./TransactionsTable";

interface TransactionDetailsModalProps {
  withdraw: any | null;
  onClose: () => void;
}

const TransactionDetailsModal: React.FC<TransactionDetailsModalProps> = ({
  withdraw,
  onClose,
}) => {
  const items = withdraw
    ? getColumns(true).map(({ key, title: label, span = 1, render }) => ({
      key,
      label,
      children: render ? render(withdraw[key], withdraw) : withdraw[key] || "-",
      span,
    }))
    : [];


  return (
    <Modal
      closeIcon={<CloseOutlined className="print-hide" />}
      footer={
        <>
          <Button className="print-hide" icon={<PrinterOutlined />} onClick={() => window.print()}>
            پرینت
          </Button>
          <Button className="print-hide" onClick={onClose}>
            بستن
          </Button>
        </>
      }
      open={Boolean(withdraw)}
      title="تراکنش"
      onCancel={onClose}
    >
      <Space wrap styles={{ item: { minWidth: "40%", padding: 4 } }}>
        {items.map(({ key, label, children }) => (
          <Space key={key} wrap>
            <Typography.Text>{label}:</Typography.Text>
            <Typography.Text strong>{children}</Typography.Text>
          </Space>
        ))}
      </Space>
    </Modal>
  );
};

export default TransactionDetailsModal;

